module.exports = __webpack_public_path__ + "static/media/ciudadlibre.c55cf206.png";